import React from 'react'
import PropTypes from 'prop-types'

import { FilterTable } from 'camino-react'

const TicketTypeTable = ({ data }) => {
  const columns = [
    { text: 'Region', accessor: 'region_name' },
    { text: 'Client', accessor: 'client_name' },
    { text: 'Name', accessor: 'name' },
    { text: 'Description', accessor: 'description' },
    { text: 'Internal', accessor: 'internal', Cell: row => (row.value ? 'True' : 'False') }
  ]

  return (
    <FilterTable
      data={data}
      columns={columns}
      localStoragePrefix="TicketTypeTable"
    />
  )
}

TicketTypeTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default TicketTypeTable
